<mat-sidenav-container class="wrapper" [hasBackdrop]="false">
  <mat-sidenav #sidenav class="sidenav" mode="push" [(opened)]="sidebarOpened">
    <app-admin-sidemenu></app-admin-sidemenu>
  </mat-sidenav>

  <div class="sidenav-content">
    <mat-toolbar color="primary">
      <i class="fa fa-bars" (click)="sidenav.toggle()" (keyup)="$event.keyCode === 13 && sidenav.toggle()" tabindex></i>
      <div class="expander"></div>

        @if (isAdmin()) {

          @if (loading()) {
            <div class="toggle-sidebar">
              <mat-icon>hourglass_empty</mat-icon>
            </div>
          }
          @else if (error) {
            <div class="toggle-sidebar error" matTooltip="Ha ocurrido un error al cargar las advertencias de configuración">
              <mat-icon>error</mat-icon>
            </div>
          }
          @else if (warnings.length > 0) {
            <div class="toggle-sidebar" (click)="openWarningsDialog()" (keyup)="$event.keyCode === 13 && openWarningsDialog()" tabindex>
              <mat-icon>warnings</mat-icon>
              <div class="counter">
                {{ warnings.length }}
              </div>
            </div>
          } @else {
            <div class="toggle-sidebar success" matTooltip="No hay errores de configuración">
              <mat-icon>check</mat-icon>
            </div>
          }
        }
    </mat-toolbar>
    <router-outlet></router-outlet>
  </div>

</mat-sidenav-container>
